__turbopack_context__.v({
  "container": "styles-module-scss-module__zuwn2G__container",
  "large": "styles-module-scss-module__zuwn2G__large",
  "medium": "styles-module-scss-module__zuwn2G__medium",
});
